export const AISearchTooltipLocalStorageKey = "newSearchTooltipDismissed";
